
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { RangerEntityDecorator } from '../../ranger/model/ranger.decorator';
import { Ranger } from '../../ranger/model/ranger.model';
import { AssetsUserDetailsEntityDecorator } from '../../userdetails/model/assets-user-details.decorator';
import { AssetsUserDetails } from '../../userdetails/model/assets-user-details.model';
import { FIREARM_ASSIGNABLE_PERSON_METADATA } from './firearm-assignable-person.metadata';
import { FirearmAssignablePerson } from './firearm-assignable-person.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmAssignablePersonEntityDecoratorBase extends GenericEntityDecorator<FirearmAssignablePerson, string> {
  constructor() {
    super(FIREARM_ASSIGNABLE_PERSON_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get ranger(): EntityDecorator<Ranger, number> {
        return new RangerEntityDecorator();
      },
      get user(): EntityDecorator<AssetsUserDetails, string> {
        return new AssetsUserDetailsEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.personId == null) {
      return null;
    }
    return params.personId;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: FirearmAssignablePerson): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




